import { useEffect, useState } from "react";
import RadioButton from "../../component/ui/RadioButton";
import Input from "../../component/ui/Input";
import Textarea from "../../component/ui/Textarea";
import Button from "../../component/ui/Button";
import {
  ageGroup,
  CARDS_ENUMS,
  crewCategories,
  EVENT_GENDERS,
  roles,
} from "../../helper/constant";
import SelectField from "../../component/ui/SelectField";
import profile from "../../assets/profile.png";
import DateAndTimePicker from "../../component/ui/Datepicker";
import RangeInput from "../../component/ui/ReactRange";
import { useLoginData } from "component/common/loginData";
import MultiSelectWrapper from "component/ui/MultiSelectWrapper";
import { FaPlus, FaUser } from "react-icons/fa";
import SearchInput from "component/ui/SearchInput";
import { FiSearch } from "react-icons/fi";
import PageContainer from "component/ui/PageContainer";
import PageHeading from "component/ui/PageHeading";
import UserNameHeader from "component/UserNameHeader";
import { useDispatch, useSelector } from "react-redux";
import { PhoneNumber } from "component/ui/PhoneNumber";
import moment from "moment";
import {
  convertDateTimeUtc,
  createUniqueId,
  isValidNumber,
} from "helper/appConstant";
import { toast } from "react-toastify";
import {
  createRequestService,
  getServiceDetails,
  selectCrewOrAssociation,
  updateRequestService,
} from "store/slice/booking";
import { useNavigate, useParams } from "react-router-dom";
import FullPageLoader from "component/ui/fullPageLoader";
import LocationPicker from "component/ui/LocationPicker";

const RequestService = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [selectedPlayer, setSelectedPlayer] = useState(false);
  const userData = useLoginData();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [position, setPosition] = useState();
  const [formData, setFormData] = useState({
    venueName: userData?.name,
    budget: 0,
    cardReferenceType: "no",
    cardReferenceID: createUniqueId(CARDS_ENUMS?.SERVICE),
  });
  const { configData } = useSelector((state) => state.auth);
  const { crewAssocialtionList } = useSelector((state) => state.booking);
  const [loader, setLoader] = useState(false);
  const { serviceDetailsData } = useSelector((state) => state.booking);

  useEffect(() => {
    if (id && id != "new") {
      setLoader(true);
      dispatch(getServiceDetails(id, setLoader));
    }
  }, [id]);
  //  set event details data to state
  useEffect(() => {
    if (serviceDetailsData && id) {
      setFormData({
        ...serviceDetailsData,
        startDate: moment(serviceDetailsData?.startDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ),
        endDate: moment(serviceDetailsData?.endDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ),
        coordinates: serviceDetailsData?.location?.coordinates,
        address: serviceDetailsData?.location?.address,
        contactNo: String(serviceDetailsData?.contactNo),
        crewOrAssocianFullname: serviceDetailsData?.crewOrAssocianname,
        crewOrAssocianname: serviceDetailsData?.crewId,
      });
    }
  }, [serviceDetailsData]);
  //   set current location
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      if (pos?.coords?.latitude && pos?.coords?.longitude) {
        setPosition({
          lat: pos?.coords?.latitude,
          lng: pos?.coords?.longitude,
        });
      }
    });
  }, []);
  // handle change function fields
  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if (userData) {
      fetchCrewAssociation();
    }
  }, [userData]);
  // fetch Crew/Association list
  const fetchCrewAssociation = (searchQuery) => {
    const request = {
      language: "en",
      page: 1,
      perPage: 20,
      searchQuery: searchQuery ?? "",
      userCountry: null,
      sportName: null,
      productCountry: null,
      latitude:
        userData?.location?.coordinates?.length > 0
          ? userData?.location?.coordinates[1]
          : position?.lat,
      longitude:
        userData?.location?.coordinates?.length > 0
          ? userData?.location?.coordinates[0]
          : position?.lng,
    };
    dispatch(selectCrewOrAssociation(request));
  };
  // validation
  const validateEventFields = () => {
    const requiredFields = [
      { key: "cardReferenceID", label: "card Reference ID" },
      { key: "serviceName", label: "service sought" },
      { key: "prefGender", label: "Gender" },
      { key: "category", label: "Game / Sport" },
      { key: "ageGroup", label: "Age group" },
      { key: "noOfCrew", label: "Number of Crew" },
      { key: "crewOrAssocianFullname", label: "Crew/Association Name" },
      ...(userData?.userType != roles.CLUB
        ? [
            { key: "contactNo", label: "Contact number" },
            { key: "isBringYourOwnEquipment", label: "" },
          ]
        : []),

      { key: "startDate", label: "Start date" },
      { key: "startTime", label: "Start time" },
      { key: "endDate", label: "End date" },
      { key: "endTime", label: "End time" },
    ];

    for (let field of requiredFields) {
      const value = formData?.[field.key];
      if (
        field?.key === "isBringYourOwnEquipment" &&
        (value === undefined || value === null)
      ) {
        toast.error("Please select kit is required or not");
        return;
      }
      // empty / blank check
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        toast.error(`${field.label} is required`);
        return false;
      }

      if (field?.key === "phone" && !isValidNumber(value?.slice(3))) {
        toast.error("Please enter a valid phone number");
        return;
      }
    }

    return true;
  };
  const handleSuccess = (status) => {
    if (status) {
      if (formData?.id) {
        navigate("/my-posting");
      } else {
        navigate("/dashboard");
      }
    }
    setLoader(false);
  };
  // handle add update service
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEventFields()) return;
    if (userData?.userType == roles.CLUB && !formData?.location?.address) {
      toast.error("Please enter venue address");
      return;
    }
    setLoader(true);
    const request = {
      ...formData,
      countryName: formData?.countryName ?? "India",
      startDateTimeUtc: convertDateTimeUtc(
        formData?.startDate,
        formData?.startTime
      ),
      venueName: userData?.id,
      noOfCrew: formData?.noOfCrew * 1,
      endDateTimeUtc: convertDateTimeUtc(formData?.endDate, formData?.endTime),
      address:
        userData?.userType != roles.CLUB
          ? userData?.location?.address
          : formData?.location?.address,
      coordinates:
        userData?.userType != roles.CLUB
          ? userData?.location?.coordinates
          : formData?.location?.coordinates,
      crewOrAssocianname: formData?.crewOrAssocianname
        ? formData?.crewOrAssocianname
        : null,
    };

    if (formData?.id) {
      const updateRequest = { ...request, serviceId: formData?.id };
      dispatch(updateRequestService(updateRequest, handleSuccess));
    } else {
      dispatch(createRequestService(request, handleSuccess));
    }
  };
  return (
    <PageContainer>
      <div className="lg:max-w-5xl w-full mx-auto">
        <PageHeading
          title={"Request a service"}
          // Subtitle={"Request/Book Sports Crew"}
        />
      </div>

      {/* Form Fields */}
      <form
        onSubmit={handleSubmit}
        className="lg:max-w-5xl w-full mx-auto lg:p-6 p-3 rounded-lg bg-white space-y-4"
      >
        {loader && <FullPageLoader />}
        <UserNameHeader />
        {!formData?.id && (
          <>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
              <RadioButton
                label="Do you have a reference id"
                isRequired={true}
                selected={formData?.cardReferenceType}
                options={["Yes", "No"]}
                onChange={(e) => {
                  if (e.target.value == "yes") {
                    handleChange("cardReferenceID", "");
                  } else {
                    handleChange(
                      "cardReferenceID",
                      createUniqueId(CARDS_ENUMS?.SERVICE)
                    );
                  }
                  handleChange("cardReferenceType", e.target.value);
                }}
              />
            </div>
            {/* reference id */}
            <Input
              label="Enter reference id"
              placeholder="Enter a valid reference id"
              required
              disabled={formData?.cardReferenceType == "no"}
              value={formData?.cardReferenceID}
              onChange={(e) => handleChange("cardReferenceID", e)}
              className="w-full"
            />
          </>
        )}
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          {/* Service sought*/}
          <Input
            label="Service sought"
            isRequired={true}
            value={formData?.serviceName}
            onChange={(e) => handleChange("serviceName", e)}
            placeholder="Umpire/Coach/Referee/Physiotherapist etc."
          />

          <SelectField
            label="Preferred gender"
            placeholder="Gender"
            options={EVENT_GENDERS}
            onChange={(value) => handleChange("prefGender", value)}
            value={formData?.prefGender}
            isRequired={true}
          />
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          <SelectField
            label="Select game or sport"
            isSport
            placeholder="Select game or sport"
            onChange={(value) => handleChange("category", value)}
            options={configData?.gamesDetails}
            value={formData?.category}
            isRequired={true}
          />

          <SelectField
            id="age-select"
            label="Age group playing"
            placeholder="Age Group Playing"
            name="age"
            options={ageGroup}
            onChange={(value) => handleChange("ageGroup", value)}
            value={formData?.ageGroup}
          />
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          <SelectField
            label="No of crew required"
            onChange={(value) => handleChange("noOfCrew", value)}
            value={formData?.noOfCrew}
            options={Array.from({ length: 25 }, (_, i) => i + 1)}
            isRequired={true}
            placeholder="Enter number of crew required"
          />
          <div>
            <Input
              disabled
              label="Venue Name"
              value={userData?.name}
              isRequired={true}
            />
          </div>

          {/* {userData?.userType === roles.CLUB && (
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Your skill level <span className="text-red-500 ml-1">*</span>
              </label>

              <MultiSelectWrapper
                label="Accessibility"
                isRequired
                placeholder="Beginner,Intermediate & Advanced"
              />
            </div>
          )} */}
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
          <Input
            label="Crew/Associations name "
            required
            value={formData?.crewOrAssocianFullname}
            onFocus={() => setSelectedPlayer(true)}
            placeholder="Enter User Name"
          />

          {userData?.userType === roles.VENUE ? (
            <PhoneNumber
              label="Contact number"
              placeholder="Phone number"
              onChange={(val) =>
                setFormData((formData) => ({
                  ...formData,
                  contactNo: val?.countryCode + val?.phoneNumber,
                }))
              }
              phone={formData?.contactNo}
            />
          ) : (
            <div>
              <label className="block text-sm font-semibold text-gray-700 ">
                Venue Location
                <span className="text-red-500 ml-1 font-bold">*</span>
              </label>
              <div className="pt-1">
                <LocationPicker
                  onChange={(place) => {
                    const obj = {
                      address: place?.formatted_address,
                      coordinates: [
                        place?.geometry?.location?.lng(),
                        place?.geometry?.location?.lat(),
                      ],
                    };
                    setFormData((prev) => ({
                      ...prev,
                      location: obj,
                    }));
                  }}
                  value={formData?.location?.address}
                  placeholder={"search an address"}
                />
              </div>
            </div>
          )}
        </div>
        {userData?.userType === roles.VENUE ? (
          <>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
              <Textarea
                id="description"
                label="Description"
                placeholder="Enter description"
                rows={4}
                value={formData?.description}
                onChange={(e) => handleChange("description", e.target.value)}
              />

              <Textarea
                id="requirements"
                label="Comments / Additional Information"
                placeholder="Enter comments here."
                rows={4}
                value={formData?.comments}
                onChange={(e) => handleChange("comments", e.target.value)}
              />
            </div>
            {/* Kit required */}
            <RadioButton
              label="Kit required"
              options={["Yes", "No"]}
              selected={
                formData?.isBringYourOwnEquipment != null ||
                formData?.isBringYourOwnEquipment != undefined
                  ? formData?.isBringYourOwnEquipment
                    ? "yes"
                    : "no"
                  : ""
              }
              onChange={(e) => {
                handleChange(
                  "isBringYourOwnEquipment",
                  e.target.value == "yes"
                );
                if (e.target.value == "no") {
                  handleChange("yourOwnEquipment", "");
                }
              }}
              isRequired={true}
            />
            {formData?.isBringYourOwnEquipment && (
              <Input
                placeholder="Enter the detail of kit items required"
                required
                value={formData?.yourOwnEquipment}
                onChange={(e) => handleChange("yourOwnEquipment", e)}
                className="w-full"
              />
            )}
          </>
        ) : (
          ""
        )}
        <div className="space-y-4 border-t border-gray-200">
          <h2 className="md:text-xl text-lg font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
            <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
            Service Schedule
          </h2>

          <label className="text-sm md:font-semibold font-medium text-gray-700">
            Start Date & Time
            <span className="text-red-500 ml-1 font-bold">*</span>
          </label>
          <div
            className="grid grid-cols-1 md:grid-cols-2 gap-2 "
            style={{ marginTop: "0.3rem", marginBottom: "1rem" }}
          >
            <DateAndTimePicker
              showDate
              showTime={false}
              minDate={new Date()}
              selectedDate={formData?.startDate}
              onDateChange={(date) =>
                handleChange(
                  "startDate",
                  date ? moment(date).format("YYYY-MM-DD") : ""
                )
              }
              placeholderDate="Start Date"
              placeholderTime="Start Time"
              isRequired
              inputClassName="w-full"
            />
            <Input
              type="time"
              // label={"Time"}
              isRequired
              value={formData?.startTime}
              onChange={(time) => handleChange("startTime", time)}
            />
          </div>

          <label className="text-sm md:font-semibold font-medium text-gray-700">
            End Date & Time
            <span className="text-red-500 ml-1 font-bold">*</span>
          </label>
          <div
            className="grid grid-cols-1 md:grid-cols-2 gap-2"
            style={{ marginTop: "0.3rem" }}
          >
            <DateAndTimePicker
              showDate
              showTime={false}
              minDate={formData?.startDate ?? new Date()}
              selectedDate={formData?.endDate}
              onDateChange={(date) =>
                handleChange(
                  "endDate",
                  date ? moment(date).format("YYYY-MM-DD") : ""
                )
              }
              placeholderDate="end Date"
              isRequired
              inputClassName="w-full"
            />
            <Input
              type="time"
              isRequired
              value={formData?.endTime}
              onChange={(time) => handleChange("endTime", time)}
            />
          </div>
        </div>
        <div className="pt-4 border-t border-gray-200">
          <h2 className="text-lg font-semibold ">Service Budget</h2>
          <RangeInput
            label="Budget"
            placeholder="Enter Budget"
            min={0}
            max={2000}
            step={1}
            value={formData?.budget}
            onChange={(val) => handleChange("budget", val)}
          />
        </div>
        {userData?.userType === roles.CLUB && (
          <>
            {/* <div>
              <h2 className="md:text-xl text-lg font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
                <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
                🎓 Crew Specialisation
              </h2>

              {crewCategories.map((category, index) => (
                <div key={index} className="border-b last:border-b-0">
                  <button
                    type="button"
                    onClick={() => toggleAccordion(index)}
                    className="w-full flex justify-between items-center py-3 text-left font-medium"
                  >
                    <span>• {category.title}</span>
                    <span className="text-xl">
                      {openIndex === index ? "⌃" : "⌄"}
                    </span>
                  </button>

                  {openIndex === index && category.options.length > 0 && (
                    <div className="pl-4 pb-3 space-y-3">
                      {category.options.map((option, i) => (
                        <label
                          key={i}
                          className="flex items-center justify-between cursor-pointer"
                        >
                          <span className="text-sm text-gray-700 md:w-full w-56">
                            {option}
                          </span>
                          <input
                            type="radio"
                            name="crewRole"
                            value={option}
                            className="w-4 h-4 text-blue-600"
                          />
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <Textarea
              id="message"
              label="Short note"
              // value={message}
              // onChange={handleMessageChange}
              placeholder="Please enter your note"
            /> */}

            {/* <div>
              <h2 className="md:text-xl text-lg font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
                <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
                <FaPlus fill="#ff0000" /> Extras
              </h2>

              <Textarea
                id="message"
                label="Description"
                // value={message}
                // onChange={handleMessageChange}
                placeholder="Enter description"
                rows={6}
              />
            </div> */}
          </>
        )}
        <div className="flex items-center justify-center mt-12">
          <Button variant="primary" size="sm">
            Request Service
          </Button>
        </div>
      </form>

      {selectedPlayer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fadeIn">
            <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-white">Venue name</h3>
              <button
                onClick={() => setSelectedPlayer(null)}
                className="text-white text-xl hover:opacity-80"
              >
                ✕
              </button>
            </div>

            <div className="p-4">
              <SearchInput
                onChange={(e) => fetchCrewAssociation(e.target.value)}
                placeholder="Search.."
                icon={FiSearch}
              />

              <div className="overflow-y-auto md:h-96 h-72 thin-scrollbar">
                {crewAssocialtionList?.map((item, index) => (
                  <div className="flex border-b pb-1 items-center justify-between my-3 pr-4 cursor-pointer">
                    <div
                      onClick={() => {
                        setFormData((formData) => ({
                          ...formData,
                          crewOrAssocianname: item?.id,
                          crewOrAssocianFullname: item?.name,
                        }));
                        setSelectedPlayer(null);
                      }}
                      className="flex items-center md:gap-5 gap-3"
                    >
                      <div className="md:w-10 md:h-10 w-7 h-7 font-semibold text-white rounded-full bg-highlight flex justify-center items-center">
                        {item?.name && item?.name?.charAt(0)?.toUpperCase()}
                      </div>
                      <p className="md:text-base text-sm">{item?.name}</p>
                    </div>
                    <FaUser
                      fill="#2bace2"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/player-details/${item?.id}`);
                      }}
                    />
                  </div>
                ))}
                <div
                  onClick={() => {
                    setFormData((formData) => ({
                      ...formData,
                      crewOrAssocianname: null,
                      crewOrAssocianFullname: "Not Listed",
                    }));
                    setSelectedPlayer(null);
                  }}
                  className="flex border-b pb-1 items-center justify-between my-3 pr-4 cursor-pointer"
                >
                  <div className="flex items-center md:gap-5 gap-3">
                    <div className="md:w-10 md:h-10 w-7 h-7 font-semibold text-white rounded-full bg-highlight flex justify-center items-center">
                      N
                    </div>
                    <p className="md:text-base text-sm">Not Listed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </PageContainer>
  );
};

export default RequestService;
